import { useRequesterStore } from '../stores/requester'
let requesterX: any

export async function createbilling(body: any) {
  try {
    requesterX = requesterX ? requesterX : useRequesterStore()
    body.date = body.date.toLocaleDateString('es-EC', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    })
    const resp = await requesterX.Post({
      route: `/billing/create`,
      withAuth: true,
      body,
    })

    return resp
  } catch (e) {
    throw e
  }
}
export async function getAllInvoices(otherIncomings = false) {
  try {
    requesterX = requesterX ? requesterX : useRequesterStore()
    const resp = await requesterX.Get({
      route: `/billing/get-all?otherIncomings=${otherIncomings}`,
      withAuth: true,
    })
    return resp
  } catch (e) {
    throw e
  }
}

export async function updatebilling(body: any) {
  try {
    requesterX = requesterX ? requesterX : useRequesterStore()
    const resp = await requesterX.Put({
      route: `/billing/update`,
      withAuth: true,
      body,
    })

    return resp
  } catch (e) {
    throw e
  }
}

export async function deletebilling(id: string) {
  try {
    requesterX = requesterX ? requesterX : useRequesterStore()
    const resp = await requesterX.Delete({
      route: `/billing/delete/${id}`,
      withAuth: true,
    })

    return resp
  } catch (e) {
    throw e
  }
}

export async function getInvoiceDetail(id: string) {
  try {
    requesterX = requesterX ? requesterX : useRequesterStore()
    const resp = await requesterX.Get({
      route: `/billing/${id}`,
      withAuth: true,
    })
    return resp
  } catch (e) {
    throw e
  }
}

export async function getPaymentMethods() {
  try {
    requesterX = requesterX ? requesterX : useRequesterStore()
    const resp = await requesterX.Get({
      route: `/billing/payment-methods/get-all`,
      withAuth: true,
    })
    return resp
  } catch (e) {
    throw e
  }
}
export async function bulkAdd(body: any) {
  try {
    requesterX = requesterX ? requesterX : useRequesterStore()
    const resp = await requesterX.Post({
      route: `/billing/bulk-create`,
      withAuth: true,
      body,
    })

    return resp
  } catch (e) {
    throw e
  }
}

export async function checkInvoice(id: string) {
  try {
    requesterX = requesterX ? requesterX : useRequesterStore()
    const resp = await requesterX.Get({
      route: `/billing/validate/${id}`,
      withAuth: true,
    })

    return resp
  } catch (e) {
    throw e
  }
}

export async function sendInvoice(id: string) {
  try {
    requesterX = requesterX ? requesterX : useRequesterStore()
    const resp = await requesterX.Get({
      route: `/billing/send-invoice/${id}`,
      withAuth: true,
    })

    return resp
  } catch (e) {
    throw e
  }
}

export async function getAllClient(cedulaCliente = null) {
  try {
    requesterX = requesterX ? requesterX : useRequesterStore()
    const resp = await requesterX.Get({
      route: `/customer/search/${cedulaCliente}`,
      withAuth: true,
    })
    return resp
  } catch (e) {
    throw e
  }
}
export async function getCategories(type = 'I', scope?: string) {
  try {
    requesterX = requesterX ? requesterX : useRequesterStore()
    const query = scope ? `?type=${type}&scope=${scope}` : `?type=${type}`
    const resp = await requesterX.Get({
      route: `/category${query}`,
      withAuth: true,
    })

    return resp
  } catch (e) {
    throw e
  }
}
export async function sendWhatsApp(id: string) {
  try {
    requesterX = requesterX ? requesterX : useRequesterStore()
    const resp = await requesterX.Get({
      route: `/billing/whatsapp/${id}`,
      withAuth: true,
    })
    return resp
  } catch (e) {
    throw e
  }
}

export async function createCreditNote(body: any) {
  try {
    requesterX = requesterX ? requesterX : useRequesterStore()
    body.fechaEmision = body.fechaEmision.toLocaleDateString('es-EC', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    })
    const resp = await requesterX.Post({
      route: `/billing/credit-note`,
      withAuth: true,
      body,
    })

    return resp
  } catch (e) {
    throw e
  }
}
